import React, { FunctionComponent, useEffect, useState } from 'react';
import { Button } from 'rs-emd-ui-atoms';
import { useSwiper } from 'swiper/react';
import styles from './carousel-nav-buttons-component.module.scss';

export const CarouselNavButtons: FunctionComponent = () => {
  const swiper = useSwiper();
  const [slideConfig, setSlideConfig] = useState({
    isBeginning: true,
    isEnd: false,
  });

  useEffect(() => {
    const handleSlideChange = () => {
      setSlideConfig({ isBeginning: swiper.isBeginning, isEnd: swiper.isEnd });
    };

    swiper.on('slideChange', handleSlideChange);
    return () => {
      swiper.off('slideChange', handleSlideChange);
    };
  }, [swiper]);

  return (
    <div className={styles['navigation-btns']}>
      <Button
        className={`${styles.arrow} ${styles.left}`}
        buttonType='text'
        icon='chev-left'
        onClick={() => swiper.slidePrev()}
        disabled={slideConfig.isBeginning}
      />
      <Button
        className={`${styles.arrow} ${styles.right}`}
        buttonType='text'
        size='full-width'
        icon='chev-right'
        onClick={() => swiper.slideNext()}
        disabled={slideConfig.isEnd}
      />
    </div>
  );
};

export default CarouselNavButtons;
